<!-- Translated: yes -->
<template>
  <div :class="'field field--' + type" @click="$emit('click')">
    <label v-if="label">{{ label }} <span v-if="required" class="required">*</span></label>
    <input type="text" name="" :value="text" @keyup="changeText" @keyup.enter="changeText" :placeholder="placeholder" @blur="changeText">
  </div>
</template>

<script>
export default {
  props: {
    value: {},
    placeholder: {},
    keyenter: {
      type: Function,
    },
    type: {
      default: 'normal',
    },
    label: {
      default: '',
    },
    required: {},
  },
  data() {
    return {
      text: this.value,
    };
  },
  methods: {
    changeText(event) {
      this.text = event.target.value;
      this.$emit('change', this.text);
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~@/global.styl'

.field
  margin-bottom 15px

input
  input()
  max-width: 100%

label
  uppercase()
  font-size 11px
  font-weight bold
  text-align: left

</style>



// WEBPACK FOOTER //
// LabelInput.vue?3bdc6ea4